/* ============================================================
   pc-configurator-ssd.js
   Multi-select support for the "ssd" category — lets the user
   add several DIFFERENT SSDs (and a per-item quantity for each).
   All cart / total / share / URL-encode logic already handles
   arrays generically in the main pc-configurator.js — this
   sub-script only handles:
     1. selectProduct / deselectProduct to maintain an array
     2. Category sidebar render (avoid array.title crash)
     3. Per-card +/- quantity UI and selected "Retirer" button
     4. Best-effort restore of a multi-SSD share/URL config
   Modeled on pc-configurator-ventilateur.js.
   ============================================================ */
(function(){
  'use strict';

  function waitForExports(cb, n) {
    if (window.__ventS && window.__ventR && window.__ventC && window.__ventU && window.__ventD) return cb();
    if (n > 50) return console.warn('[SSD] Timeout waiting for exports');
    setTimeout(function(){ waitForExports(cb, (n || 0) + 1); }, 100);
  }

  waitForExports(function(){
    var STATE  = window.__ventS;
    var Render = window.__ventR;
    var CONFIG = window.__ventC;
    var Utils  = window.__ventU;
    var DOM    = window.__ventD;

    var CAT = 'ssd';
    var MAX_QTY = 8; // per distinct SSD

    /* --- Visual styles (mirror the fan controls, reuse blue accent) --- */
    var s = document.createElement('style');
    s.textContent = [
      '.ssd-qty-controls{display:flex;align-items:center;gap:6px;justify-content:center;margin-top:4px}',
      '.ssd-qty-btn{width:28px;height:28px;border-radius:50%;border:1.5px solid #0066FF;background:#fff;color:#0066FF;font-size:16px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .15s;line-height:1;padding:0}',
      '.ssd-qty-btn:hover{background:#0066FF;color:#fff}',
      '.ssd-qty-val{font-size:15px;font-weight:600;min-width:20px;text-align:center;color:#222}',
      '.ssd-remove-btn{display:block;width:100%;margin-top:6px;padding:6px 0;border:none;border-radius:6px;background:#fee;color:#d33;font-size:12px;font-weight:600;cursor:pointer;transition:all .15s}',
      '.ssd-remove-btn:hover{background:#d33;color:#fff}',
      '.product-card.ssd-selected{border:2px solid #0066FF!important;box-shadow:0 0 12px rgba(0,102,255,0.15)!important}',
      '.product-card.ssd-selected .product-action{display:none!important}'
    ].join('\n');
    document.head.appendChild(s);

    function getSsdArr(){ return Array.isArray(STATE.build[CAT]) ? STATE.build[CAT] : []; }

    /* Keep the blue checkout bar, sidebar, cards and URL in sync after a change. */
    function afterChange() {
      try { Render.updateTotal(); } catch(e) { console.warn('[SSD] updateTotal failed', e); }
      try { Render.categories(); } catch(e) { console.warn('[SSD] categories failed', e); }
      try { Render.renderNextButton(); } catch(e) {}
      try { Render.products(); } catch(e) {}
      try { Utils.setUrlParams(STATE.build); } catch(e) {}
      _lastSsdSig = '__force__';
      setTimeout(applySsdUI, 30);
      setTimeout(applySsdUI, 150);
      setTimeout(applySsdUI, 400);
    }

    function removeSsd(pid){
      pid = parseInt(pid, 10);
      var arr = getSsdArr();
      STATE.build[CAT] = arr.filter(function(f){ return f.id !== pid; });
      if (STATE.build[CAT].length === 0) delete STATE.build[CAT];
      afterChange();
    }

    function setSsdQty(pid, qty){
      pid = parseInt(pid, 10);
      qty = parseInt(qty, 10);
      if (qty <= 0) return removeSsd(pid);
      if (qty > MAX_QTY) qty = MAX_QTY;
      var arr = getSsdArr();
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id === pid) { arr[i].qty = qty; break; }
      }
      afterChange();
    }

    /* --- Inject +/- and Remove controls onto selected SSD cards --- */
    var _applyingSsdUI = false;
    var _lastSsdSig = '';
    var _lastCardCount = 0;
    function applySsdUI() {
      if (STATE.activeCategory !== CAT) return;
      if (_applyingSsdUI) return;
      var arr = getSsdArr();
      var cards = document.querySelectorAll('.product-card');
      var sig = JSON.stringify(arr.map(function(v){return v.id + ':' + (v.qty || 1);})) + '|' + cards.length;
      if (sig === _lastSsdSig && cards.length === _lastCardCount) return;
      _lastSsdSig = sig;
      _lastCardCount = cards.length;
      _applyingSsdUI = true;
      try { observer.disconnect(); } catch(e) {}

      for (var c = 0; c < cards.length; c++) {
        var card = cards[c];
        var pid = card.getAttribute('data-product-id');
        if (!pid) continue;
        pid = parseInt(pid, 10);
        var sel = null;
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].id === pid) { sel = arr[i]; break; }
        }
        var old = card.querySelector('.ssd-controls-wrap');
        if (old) old.remove();
        var btn = card.querySelector('.product-action');
        if (sel) {
          card.classList.add('selected', 'ssd-selected');
          var ov = card.querySelector('.product-selected-overlay');
          if (ov) ov.style.display = '';
          if (btn) btn.style.display = 'none';
          var wrap = document.createElement('div');
          wrap.className = 'ssd-controls-wrap';
          wrap.style.cssText = 'padding:0 10px 10px;';
          var qd = document.createElement('div');
          qd.className = 'ssd-qty-controls';
          var mb = document.createElement('button');
          mb.className = 'ssd-qty-btn';
          mb.textContent = '−';
          mb.setAttribute('data-pid', pid);
          mb.setAttribute('data-action', 'ssd-minus');
          var qs = document.createElement('span');
          qs.className = 'ssd-qty-val';
          qs.textContent = sel.qty || 1;
          var pb = document.createElement('button');
          pb.className = 'ssd-qty-btn';
          pb.textContent = '+';
          pb.setAttribute('data-pid', pid);
          pb.setAttribute('data-action', 'ssd-plus');
          qd.appendChild(mb); qd.appendChild(qs); qd.appendChild(pb);
          var rb = document.createElement('button');
          rb.className = 'ssd-remove-btn';
          rb.textContent = '✕ ' + (window.__SH_DE ? 'Entfernen' : 'Retirer');
          rb.setAttribute('data-pid', pid);
          rb.setAttribute('data-action', 'ssd-remove');
          wrap.appendChild(qd);
          wrap.appendChild(rb);
          card.appendChild(wrap);
        } else {
          card.classList.remove('selected', 'ssd-selected');
          var ov2 = card.querySelector('.product-selected-overlay');
          if (ov2) ov2.style.display = 'none';
          if (btn) { btn.style.display = ''; }
        }
      }
      _applyingSsdUI = false;
      setTimeout(function(){ try { startObserving(); } catch(e) {} }, 80);
    }

    /* --- Click handler on +/-/remove buttons --- */
    document.addEventListener('click', function(e){
      var tgt = e.target.closest('[data-action]');
      if (!tgt) return;
      var action = tgt.getAttribute('data-action');
      if (action !== 'ssd-minus' && action !== 'ssd-plus' && action !== 'ssd-remove') return;
      var pid = tgt.getAttribute('data-pid');
      if (!pid) return;
      pid = parseInt(pid, 10);
      var arr = getSsdArr();
      if (action === 'ssd-minus') {
        e.preventDefault(); e.stopPropagation();
        for (var i = 0; i < arr.length; i++) if (arr[i].id === pid) { setSsdQty(pid, (arr[i].qty || 1) - 1); break; }
      } else if (action === 'ssd-plus') {
        e.preventDefault(); e.stopPropagation();
        for (var j = 0; j < arr.length; j++) if (arr[j].id === pid) { setSsdQty(pid, (arr[j].qty || 1) + 1); break; }
      } else if (action === 'ssd-remove') {
        e.preventDefault(); e.stopPropagation();
        removeSsd(pid);
      }
    }, true);

    var _ssdDebounce = null;
    var observer = new MutationObserver(function(){
      if (STATE.activeCategory !== CAT) return;
      clearTimeout(_ssdDebounce);
      _ssdDebounce = setTimeout(applySsdUI, 150);
    });
    function startObserving(){
      observer.disconnect();
      var grid = document.querySelector('.product-grid, .products-grid, .product-list, #product-grid');
      if (!grid) {
        var fc = document.querySelector('.product-card');
        grid = fc ? fc.parentElement : null;
      }
      if (grid) observer.observe(grid, { childList: true, subtree: false, attributes: false });
    }
    startObserving();

    document.querySelectorAll('[data-category]').forEach(function(btn){
      btn.addEventListener('click', function(){
        setTimeout(function(){ startObserving(); applySsdUI(); }, 500);
      });
    });

    /* --- Override selectProduct: push SSD into array with qty --- */
    var _origSelect = Render.selectProduct;
    Render.selectProduct = function(category, product) {
      if (category !== CAT) return _origSelect.call(this, category, product);
      if (!Array.isArray(STATE.build[CAT])) STATE.build[CAT] = [];
      var existing = null;
      for (var i = 0; i < STATE.build[CAT].length; i++) {
        if (STATE.build[CAT][i].id === product.id) { existing = STATE.build[CAT][i]; break; }
      }
      if (existing) {
        existing.qty = Math.min((existing.qty || 1) + 1, MAX_QTY);
      } else {
        STATE.build[CAT].push({
          id: product.id,
          title: product.title,
          variantId: product.variantId,
          price: product.price,
          tags: product.tags || [],
          compat: product.compat || {},
          qty: 1
        });
      }
      afterChange();
    };

    var _origDeselect = Render.deselectProduct;
    Render.deselectProduct = function(category) {
      if (category !== CAT) return _origDeselect.call(this, category);
      delete STATE.build[CAT];
      afterChange();
    };

    /* --- Override categories: avoid array.title crash + show count badge --- */
    var _origCat = Render.categories;
    Render.categories = function(){
      var arr = getSsdArr();
      var saved = STATE.build[CAT];
      if (arr.length > 0) {
        /* Pretend to the original renderer that the first SSD is the single
           selected product, so it can render .title and .price safely. */
        var first = arr[0];
        var sumPrice = 0;
        for (var k = 0; k < arr.length; k++) {
          var f = arr[k];
          var fp = typeof f.price === 'string' ? parseFloat(f.price) : (f.price || 0);
          sumPrice += fp * (parseInt(f.qty, 10) || 1);
        }
        STATE.build[CAT] = {
          title: arr.length === 1 ? first.title : (first.title + ' +' + (arr.length - 1)),
          price: sumPrice,
          variantId: first.variantId
        };
      }
      _origCat.call(this);
      STATE.build[CAT] = saved;

      if (arr.length === 0) return;
      var totalQ = 0;
      for (var i = 0; i < arr.length; i++) totalQ += parseInt(arr[i].qty, 10) || 1;
      var catBtns = document.querySelectorAll('[data-category="' + CAT + '"]');
      for (var b = 0; b < catBtns.length; b++) {
        var badge = catBtns[b].querySelector('.ssd-count-badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ssd-count-badge';
          badge.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;border-radius:10px;background:#0066FF;color:#fff;font-size:11px;font-weight:700;margin-left:6px;padding:0 5px;';
          catBtns[b].appendChild(badge);
        }
        badge.textContent = totalQ;
      }
    };

    /* --- Best-effort restore of a multi-SSD share/URL config --- */
    /* The main JS only parses multi-select (VARID*QTY+...) for the fan category,
       so a shared "?config=...,ssd:VARID*QTY+VARID*QTY,..." would be dropped.
       Re-parse the ssd segment here once its product pool is loaded. */
    (function restoreSsdFromUrl(){
      var params = new URLSearchParams(window.location.search);
      var cfg = params.get('config');
      if (!cfg) return;
      var ssdSeg = null;
      cfg.split(',').forEach(function(pair){
        var bits = pair.split(':');
        if (bits.length === 2 && bits[0] === CAT) ssdSeg = bits[1];
      });
      if (!ssdSeg || ssdSeg.indexOf('*') === -1) return; // nothing multi to restore

      var tries = 0;
      (function attempt(){
        var pool = STATE.products[CAT] || [];
        if (pool.length === 0) {
          if (tries++ > 60) return; // ~9s max
          return setTimeout(attempt, 150);
        }
        var items = [];
        ssdSeg.split('+').forEach(function(seg){
          var sp = seg.split('*');
          var vid = sp[0];
          var q = parseInt(sp[1], 10) || 1;
          var m = pool.find(function(p){ return String(p.variantId) === vid; });
          if (m) {
            items.push({
              id: m.id, title: m.title, variantId: m.variantId,
              price: m.price, tags: m.tags || [], compat: m.compat || {}, qty: q
            });
          }
        });
        if (items.length) {
          STATE.build[CAT] = items;
          afterChange();
        }
      })();
    })();

    console.log('[SSD] Multi-select loaded (add several different SSDs with qty)');
  });
})();
